import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton as Button } from '../../CommonComponents/Button';
import { Alert } from '../../CommonComponents/Alert/Alert';
import {
  StyledModal,
  Body,
  Footer,
  Title,
  Subtitle,
  TextArea,
  CharacterCounter,
} from './EditModalStyles';

class ExecutiveSummaryEditModalView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      executiveSummaryMessage: props.executiveSummaryMessage || '',
    };

    this.onExecutiveSummaryMessageUpdate = this.onExecutiveSummaryMessageUpdate.bind(this);
  }

  onExecutiveSummaryMessageUpdate(ev) {
    this.setState({ executiveSummaryMessage: ev.target.value });
  }

  render() {
    const {
      isOpen,
      onClose,
      onSave,
      onDelete,
      isSaving,
      isDeleting,
      errors,
      setErrors,
    } = this.props;

    const { executiveSummaryMessage } = this.state;

    return (
      <StyledModal
        isOpen={isOpen}
        shouldCloseOnOverlayClick
        showCloseModalCross
        onRequestClose={onClose}
      >
        <Body>
          {errors.length > 0 && (
            <Alert
              message={errors}
              shouldScrollOnUpdate={false}
              onRequestClose={() => setErrors([])}
            />
          )}

          <Title>Executive Summary</Title>

          <Subtitle>Add a message for this client.</Subtitle>

          <TextArea
            onChange={this.onExecutiveSummaryMessageUpdate}
            value={executiveSummaryMessage}
          />

          <CharacterCounter>
            {2500 - executiveSummaryMessage.length} Characters remaining
          </CharacterCounter>
        </Body>
        <Footer>
          <Button.Link
            disabled={isSaving || isDeleting}
            isLoading={isDeleting}
            onClick={onDelete}
            prependIcon="far fa-trash-alt"
          >
            Delete
          </Button.Link>
          <Button.Primary
            disabled={isSaving || isDeleting}
            isLoading={isSaving}
            onClick={() => onSave(executiveSummaryMessage)}
          >
            Save
          </Button.Primary>
        </Footer>
      </StyledModal>
    );
  }
}

ExecutiveSummaryEditModalView.defaultProps = {
  executiveSummaryMessage: '',
};

ExecutiveSummaryEditModalView.propTypes = {
  executiveSummaryMessage: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  setErrors: PropTypes.func.isRequired,
};

export default ExecutiveSummaryEditModalView;
